// Adjust the amounts
$('body').on('click', '.amount ul li a', function() {
    var $this = $(this);
    $('.amount ul li a').removeClass('active');
    $this.addClass('active');

    $('input[name="amount"]').val($this.data('amount'));

    return false;
});

// in own amount input selected
$('body').on('focus', 'input[name="own"]', function() {
    var $this = $(this);
    $('input[name="amount"]').val($this.val());
    $('.amount ul li a').removeClass('active');
    $this.keyup(function() {
        if($this.val() !== '') {
            // var amount = parseInt($this.val(), 10);
            // amount = isNaN(amount) ? '' : amount;
            $('input[name="amount"]').val($this.val());
            // $this.val(amount);
        } else {
            $('input[name="amount"]').val('0');
        }
    });
});

// show labels
$('body').on('focus', '.fields li input, .fields li textarea', function() {
	var $this = $(this);
	$this.keyup(function() {
		if($this.val() !== '') {
			$this.parent('li').addClass('filled').removeClass('error');
		} else {
			$this.parent('li').removeClass('filled');
		}
	});
});

$('body').on('blur', '.fields li input, .fields li textarea', function() {
    var $this = $(this);
    if($this.val() !== '') {
        $this.parent('li').addClass('filled').removeClass('error');
    } else {
        $this.parent('li').removeClass('filled');
    }
});

$('body').on('change', '.raffle-donate [name="method"]', function() {
    var $this = $(this);
    var method = $this.val();
    
    if(method === 'card') {
        $('.raffle-donate .card').parents('li').removeClass('hidden');
        $('.raffle-donate .card').addClass('required');
        return false;
    }

    if(method === 'paypal') {
        $('.raffle-donate .card').parents('li').addClass('hidden');
        $('.raffle-donate .card').removeClass('required');
    }

});

// submitting the donate form
$('body').on('submit', '.donate form, .raffle-donate form', function() {
    var $this = $(this);
    var fields = $this.serializeArray();
    fields[fields.length] = { name: "_token", value: $('meta[name="csrf-token"]').attr("content") };
    
    var error = false;
    $('.donate, .raffle-donate').find('.required').each(function () {
        var input = $(this);

        if (input.attr('type') === 'radio') {
            if (!$('.donate').find('input[name="' + input.attr('name') + '"]:checked').length) {
                error = true;
            }
        }

        if (input.attr('type') === 'checkbox') {
            if (!input.prop('checked')) {
                error = true;
            }
        }

        if (input.val() === '') {
            error = true;
        }
    });

    if(parseFloat($('.donate input[name="amount"]').val()) <= 0) {
        $('.donate .message, .raffle-donate .message').show().html('Please select an amount');
        return false;
    }

    if(error) {
        $('.donate .message, .raffle-donate .message').show().html('Please fill out all required fields');
        return false;
    }

    loading('Processing...');
    $('.donate input').prop('disabled', true);
    $('.donate .message, .raffle-donate .message').show().html('Processing');

    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            unloading();
            // console.log(data);
            $('.donate input, .raffle-donate input').prop('disabled', false);
            if (data.success) {
                $('.donate form, .raffle-donate form')[0].reset();
            }

            $('.donate .message, .raffle-donate .message').show().html(data.message);

            if(data.location) {
                window.location.href = data.location;
                return false;
            }
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});